var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("screenWMS.sortingStation")))]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.sortingStation"),
                        prop: "sortingStationNumber",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.sortingStation"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.sortingStationNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sortingStationNumber", $$v)
                          },
                          expression: "form.sortingStationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.shelves"),
                        prop: "shelvesNumber",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.shelves"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.shelvesNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "shelvesNumber", $$v)
                          },
                          expression: "form.shelvesNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.Equipment"),
                        prop: "lampNo",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.Equipment"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.lampNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lampNo", $$v)
                          },
                          expression: "form.lampNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.basketS"),
                        prop: "basketNumberStart",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.isEdit,
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.basketS"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.basketNumberStart,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "basketNumberStart", $$v)
                          },
                          expression: "form.basketNumberStart",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.basketE"),
                        prop: "basketNumberEnd",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          disabled: _vm.isEdit,
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.basketE"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.basketNumberEnd,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "basketNumberEnd", $$v)
                          },
                          expression: "form.basketNumberEnd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.address"),
                        prop: "largeScreenAddress",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.address"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.largeScreenAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "largeScreenAddress", $$v)
                          },
                          expression: "form.largeScreenAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.Printer"),
                        prop: "printerInformation",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.Printer"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.printerInformation,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "printerInformation", $$v)
                          },
                          expression: "form.printerInformation",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }